import React from 'react';
import { observer } from 'mobx-react';
import { WeaBrowser } from 'ecCom';

interface Props {
  browserConditionParam:any;
  value: string;
  valueSpan: string;
  onChange: any;
  viewAttr:string;
}

@observer
export default class Browser extends React.Component<Props, any> {
  constructor(props) {
    super(props);
  }

  render() {
    const {browserConditionParam,onChange,viewAttr}=this.props
    const browserProps = browserConditionParam || {};


    return (
      <div style={{float:'left'}}>
        {
          <WeaBrowser
            {...browserProps}
            viewAttr={viewAttr}
            onChange={onChange} /> }
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ../src4js/pc4mobx/cube/src/components/list/littleCard/table-cell/Browser.tsx